import styled, { keyframes } from "styled-components"

const shimmer = keyframes`
  from {
    background-position: -500px 0;
  }
  to {
    background-position: 500px 0;
  }
`

const BlockLoading = styled.div`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${shimmer.getName()};
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(
    to right,
    #f7f7f7 8%,
    rgba(255, 255, 255, 0.9) 18%,
    #f7f7f7 33%
  );
  background-size: 1000px 40px;
  height: 40px;
  margin-bottom: 10px;
  position: relative;
`

export default BlockLoading
